import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const DemographicsContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${barnesTheme.spacing.contentGap};
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: ${barnesTheme.spacing.contentGap} !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const SubtitleText = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.body};
  color: ${barnesTheme.colors.textLight};
  margin-top: 2px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const Hairline = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${barnesTheme.spacing.sectionGap};

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: flex-start !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
  }
`

export const PopulationCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 12px 0 !important;
  }
`

export const PopulationNumber = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 24px;
  color: ${barnesTheme.colors.text};
  line-height: 1;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 24px !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PopulationLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: 8px;
  color: ${barnesTheme.colors.textLight};
  margin-top: 8px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: 8px !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GrowthCard = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 12px 0;

  @media print {
    flex: 1 !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    justify-content: center !important;
    padding: 12px 0 !important;
  }
`

export const GrowthTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: 8px;
  color: ${barnesTheme.colors.textLight};
  margin-bottom: 8px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: 8px !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-bottom: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GrowthMetrics = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.sectionGap};

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
  }
`

export const GrowthMetric = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }
`

export const GrowthValue = styled.div<{ $accent?: boolean }>`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 24px;
  color: ${({ $accent }) =>
    $accent ? barnesTheme.colors.accent : barnesTheme.colors.text};
  line-height: 1;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 24px !important;
    color: ${({ $accent }) =>
      $accent ? barnesTheme.colors.accent : barnesTheme.colors.text} !important;
    line-height: 1 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const GrowthPeriod = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: 8px;
  color: ${barnesTheme.colors.textLight};
  margin-top: 8px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: 8px !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 8px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const MiddleRow = styled.div`
  display: flex;
  gap: ${barnesTheme.spacing.sectionGap};

  @media print {
    display: flex !important;
    gap: ${barnesTheme.spacing.sectionGap} !important;
  }
`

export const BorderedCard = styled.div`
  flex: 1;
  padding: 0;

  @media print {
    flex: 1 !important;
    padding: 0 !important;
  }
`

export const FullWidthBorderedCard = styled.div`
  padding: 0;

  @media print {
    padding: 0 !important;
  }
`

export const CardTitle = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: 13px;
  color: ${barnesTheme.colors.accent};
  margin-bottom: ${barnesTheme.spacing.smallGap};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: 13px !important;
    color: ${barnesTheme.colors.accent} !important;
    margin-bottom: ${barnesTheme.spacing.smallGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarChartRow = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 8px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    margin-bottom: 8px !important;
  }
`

export const BarChartLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  margin-bottom: 4px;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: baseline !important;
    margin-bottom: 4px !important;
  }
`

export const BarLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarPercentLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: ${barnesTheme.fontSizes.medium};
  color: ${barnesTheme.colors.text};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: ${barnesTheme.fontSizes.medium} !important;
    color: ${barnesTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarTrack = styled.div`
  width: 100%;
  height: 6px;
  background: ${barnesTheme.colors.border};
  position: relative;

  @media print {
    width: 100% !important;
    height: 6px !important;
    background: ${barnesTheme.colors.border} !important;
    position: relative !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarFill = styled.div<{ $width: number }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background: ${barnesTheme.colors.primary};

  @media print {
    height: 100% !important;
    width: ${({ $width }) => $width}% !important;
    background: ${barnesTheme.colors.primary} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BarCount = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.text};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgeGroupItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 4px !important;
  }
`

export const AgeGroupLabelRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: baseline;

  @media print {
    display: flex !important;
    justify-content: space-between !important;
    align-items: baseline !important;
  }
`

export const AgeGroupLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.light};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.textLight};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.textLight} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgeGroupValue = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-weight: ${barnesTheme.fontWeights.bold};
  font-size: ${barnesTheme.fontSizes.small};
  color: ${barnesTheme.colors.text};

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    color: ${barnesTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgeBarTrack = styled.div`
  width: 100%;
  height: 8px;
  background: ${barnesTheme.colors.border};
  position: relative;

  @media print {
    width: 100% !important;
    height: 8px !important;
    background: ${barnesTheme.colors.border} !important;
    position: relative !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgeBarFill = styled.div<{ $width: number }>`
  height: 100%;
  width: ${({ $width }) => $width}%;
  background: ${barnesTheme.colors.text};

  @media print {
    height: 100% !important;
    width: ${({ $width }) => $width}% !important;
    background: ${barnesTheme.colors.text} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AgeGroupList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    gap: 20px !important;
  }
`
